module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SocialConnectItem', {
    attrs: {
      "name": 'Microsoft',
      "disconnect": _vm.disconnect('microsoft'),
      "connectURL": _vm.microsoftURL,
      "enable": _vm.enableMicrosoft,
      "loading": this.loading['microsoft'],
      "connected": _vm.connected('microsoft')
    }
  }, [_c('MicrosoftBlack', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('SocialConnectItem', {
    attrs: {
      "name": 'Google',
      "disconnect": _vm.disconnect('google'),
      "connectURL": _vm.googleURL,
      "enable": _vm.enableGoogle,
      "loading": this.loading['google'],
      "connected": _vm.connected('google')
    }
  }, [_c('GoogleBlack', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('SocialConnectItem', {
    attrs: {
      "name": 'Clever',
      "disconnect": _vm.disconnect('clever'),
      "connectURL": _vm.cleverURL,
      "enable": _vm.enableClever,
      "loading": this.loading['clever'],
      "connected": _vm.connected('clever')
    }
  }, [_c('CleverBlack', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _vm._v(" "), (_vm.nonFieldErrors) ? _c('FormErrors', {
    attrs: {
      "errors": _vm.nonFieldErrors
    }
  }) : _vm._e(), _vm._v(" "), (_vm.emailErrors) ? _c('FormErrors', {
    attrs: {
      "errors": _vm.emailErrors
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0a6f396b"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialConnect.vue
// module id = 975
// module chunks = 0